import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Images = ({ size, color = tailwindConfig.theme.colors.black }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 6H4L4 15.3941L6.91115 12.1594L10.9492 15.6366L18.0487 8.53711L24 15.3386V6ZM4 22L4 18.3838L7.08881 14.9517L11.0508 18.3634L17.9513 11.463L24 18.3758V22H4ZM4 4C2.89543 4 2 4.89543 2 6V22C2 23.1046 2.89543 24 4 24H24C25.1046 24 26 23.1046 26 22V6C26 4.89543 25.1046 4 24 4H4ZM10 28C8.51946 28 7.22678 27.1956 6.53516 26H26C27.1046 26 28 25.1046 28 24V7.53516C29.1956 8.22678 30 9.51946 30 11V24C30 26.2092 28.2092 28 26 28H10Z"
        fill={color}
      />
    </svg>
  );
};

export default Images;
